import { __extends } from "tslib";
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(url, statusCode) {
        var _this = _super.call(this, "request to ".concat(url, " failed, status code is ").concat(statusCode)) || this;
        _this.url = url;
        _this.statusCode = statusCode;
        Object.setPrototypeOf(_this, HttpError.prototype);
        return _this;
    }
    return HttpError;
}(Error));
export { HttpError };
//# sourceMappingURL=errors.js.map